import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AuthFacade } from '../../../Facades/auth.facade';
import { CustomOfferTokenService } from '../../../Services/custom-offer-token.service';

export const customOfferLinkGuard: CanActivateFn = route => {
  const authFacade = inject(AuthFacade);
  const router = inject(Router);
  const tokenStore = inject(CustomOfferTokenService);

  const token = route.paramMap.get('token');
  if (token) {
    tokenStore.store(token);
  }

  return authFacade.initializeAuth().pipe(
    map(isAuthenticated => {
      if (isAuthenticated) {
        return router.createUrlTree(['/setup']);
      }

      authFacade.setReturnUrl('/setup');
      return router.createUrlTree(['/login']);
    }),
  );
};
